export enum SignatureType {
    PADES = 'PADES',
    XADES = 'XADES',
    XADES_DETACHEE = 'XADES_DETACHEE',
    CADES_DETACHEE = 'CADES_DETACHEE',
}
